import React, { Component } from 'react';
import PropTypes from 'prop-types';

import css from '../../styles/buttongroup';

export class ButtonGroup extends Component {
    static propTypes = {
        children: PropTypes.array,
        direction: PropTypes.string,
        className: PropTypes.string,
    };

    static defaultProps = {
        direction: 'default',
    };

    render() {
        const { direction } = this.props;
        const containerClasses = [css.container];

        if (direction === 'inline') {
            containerClasses.push(css.inline);
        }

        if (this.props.className) {
            containerClasses.push(this.props.className);
        }

        return (
            <div className={ containerClasses.join(' ') }>
                { this.props.children }
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** /src/shared/components/buttonpanel/ButtonGroup.js
 **/